package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Nicaragua Flag (20x15dp)
 *
 * - ISO Alpha-2: NI
 * - ISO Alpha-3: NIC
 * - ISO Numeric: 558
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Nicaragua: ImageVector by lazy {
    ImageVector.Builder(
        name = "Nicaragua:NI:NIC:558:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF0080EC)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(5f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF0080EC)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 10f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(10f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD0AB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10f, 5f)
                curveTo(10.118f, 5f, 10.234f, 5.008f, 10.347f, 5.024f)
                lineTo(10.223f, 5.821f)
                curveTo(10.15f, 5.812f, 10.076f, 5.807f, 10f, 5.807f)
                curveTo(9.89f, 5.807f, 9.782f, 5.817f, 9.678f, 5.837f)
                lineTo(9.62f, 5.029f)
                curveTo(9.744f, 5.01f, 9.871f, 5f, 10f, 5f)
                close()
                moveTo(10.72f, 5.105f)
                lineTo(10.503f, 5.883f)
                curveTo(11.192f, 6.097f, 11.693f, 6.74f, 11.693f, 7.5f)
                curveTo(11.693f, 7.519f, 11.693f, 7.537f, 11.692f, 7.556f)
                lineTo(12.497f, 7.624f)
                curveTo(12.499f, 7.583f, 12.5f, 7.542f, 12.5f, 7.5f)
                curveTo(12.5f, 6.37f, 11.75f, 5.414f, 10.72f, 5.105f)
                close()
                moveTo(12.196f, 8.696f)
                curveTo(11.8f, 9.422f, 11.054f, 9.93f, 10.185f, 9.993f)
                verticalLineTo(9.183f)
                curveTo(10.648f, 9.133f, 11.055f, 8.896f, 11.329f, 8.549f)
                lineTo(12.196f, 8.696f)
                close()
                moveTo(7.86f, 8.794f)
                curveTo(8.275f, 9.479f, 9.01f, 9.948f, 9.857f, 9.996f)
                verticalLineTo(9.187f)
                curveTo(9.363f, 9.146f, 8.93f, 8.893f, 8.648f, 8.519f)
                lineTo(7.86f, 8.794f)
                close()
                moveTo(7.502f, 7.607f)
                curveTo(7.501f, 7.572f, 7.5f, 7.536f, 7.5f, 7.5f)
                curveTo(7.5f, 6.438f, 8.162f, 5.531f, 9.095f, 5.169f)
                lineTo(9.304f, 5.956f)
                curveTo(8.719f, 6.22f, 8.312f, 6.806f, 8.307f, 7.488f)
                lineTo(7.502f, 7.607f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF7CDFFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.984f, 5.594f)
                lineTo(8.274f, 8.55f)
                horizontalLineTo(11.722f)
                lineTo(9.984f, 5.594f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(9.984f, 5.594f)
                lineTo(8.274f, 8.55f)
                horizontalLineTo(11.722f)
                lineTo(9.984f, 5.594f)
                close()
            }
        ) {
            path(
                stroke = SolidColor(Color(0xFFE31D1C)),
                strokeLineWidth = 0.625f
            ) {
                moveTo(10f, 9.449f)
                curveTo(10.825f, 9.449f, 11.494f, 8.78f, 11.494f, 7.955f)
                curveTo(11.494f, 7.129f, 10.825f, 6.46f, 10f, 6.46f)
                curveTo(9.175f, 6.46f, 8.506f, 7.129f, 8.506f, 7.955f)
                curveTo(8.506f, 8.78f, 9.175f, 9.449f, 10f, 9.449f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFFFFD018)),
                strokeLineWidth = 0.625f
            ) {
                moveTo(10f, 9.449f)
                curveTo(10.825f, 9.449f, 11.494f, 8.78f, 11.494f, 7.955f)
                curveTo(11.494f, 7.129f, 10.825f, 6.46f, 10f, 6.46f)
                curveTo(9.175f, 6.46f, 8.506f, 7.129f, 8.506f, 7.955f)
                curveTo(8.506f, 8.78f, 9.175f, 9.449f, 10f, 9.449f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFF4EDD00)),
                strokeLineWidth = 0.625f
            ) {
                moveTo(10f, 9.449f)
                curveTo(10.825f, 9.449f, 11.494f, 8.78f, 11.494f, 7.955f)
                curveTo(11.494f, 7.129f, 10.825f, 6.46f, 10f, 6.46f)
                curveTo(9.175f, 6.46f, 8.506f, 7.129f, 8.506f, 7.955f)
                curveTo(8.506f, 8.78f, 9.175f, 9.449f, 10f, 9.449f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFF3D58DB)),
                strokeLineWidth = 0.625f
            ) {
                moveTo(10f, 9.449f)
                curveTo(10.825f, 9.449f, 11.494f, 8.78f, 11.494f, 7.955f)
                curveTo(11.494f, 7.129f, 10.825f, 6.46f, 10f, 6.46f)
                curveTo(9.175f, 6.46f, 8.506f, 7.129f, 8.506f, 7.955f)
                curveTo(8.506f, 8.78f, 9.175f, 9.449f, 10f, 9.449f)
                close()
            }
            path(fill = SolidColor(Color(0xFF3D58DB))) {
                moveTo(8.136f, 7.636f)
                horizontalLineToRelative(3.909f)
                verticalLineToRelative(1.136f)
                horizontalLineToRelative(-3.909f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF97C923)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.398f, 8.119f)
                lineTo(9.177f, 7.345f)
                lineTo(9.416f, 7.732f)
                lineTo(9.583f, 7.259f)
                lineTo(9.769f, 7.614f)
                lineTo(9.964f, 7.345f)
                lineTo(10.216f, 7.614f)
                lineTo(10.447f, 7.259f)
                lineTo(10.645f, 7.614f)
                lineTo(10.871f, 7.345f)
                lineTo(11.401f, 7.907f)
                lineTo(11.496f, 8.119f)
                lineTo(8.398f, 8.276f)
                verticalLineTo(8.119f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NicaraguaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Nicaragua,
            contentDescription = "Nicaragua Flag"
        )
    }
}
